import React, { useCallback, useEffect } from 'react';
import { Input } from '@/components';
import { Controller, useFormContext } from 'react-hook-form';
import cx from 'clsx';
import styles from './index.module.scss';
import { ErrorMessage } from '@hookform/error-message';
import { useParseInviteLink } from './hooks';
import { debounce } from 'lodash';
import { useActionLoading } from '../ActionSelect/state';

export const JoinTelegram = () => {
  const {
    control,
    formState: { errors },
    setError,
    setValue,
    watch,
  } = useFormContext();

  const url = watch('data.action_url');
  const [, setActionLoading] = useActionLoading();

  const { mutateAsync: parseTgUrl, isLoading } = useParseInviteLink();

  useEffect(() => {
    setActionLoading(isLoading);
  }, [isLoading, setActionLoading]);

  useEffect(() => {
    if (!url) {
      setActionLoading(false);
    }
  }, [setActionLoading, url]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const validateUrl = useCallback(
    debounce(async (url: string) => {
      const res = await parseTgUrl({ chatType: 'telegram', inviteLink: url });
      if (!res?.id) {
        setValue('data.chat_name', '');
        setError('data.action_url', {
          message: 'Please input a valid Telegram invite link. Eg, https://t.me/telegram',
        });
        return;
      }
      if (res?.id && !res?.bot_has_joined) {
        setValue('data.chat_name', '');
        setValue('data.id', '');
        setError('data.action_url', {
          message: 'noTgBot',
        });
        return;
      }
      if (res.id && res.name) {
        setValue('data.chat_name', res.name);
        setValue('data.id', res.id);
        return true;
      }
    }, 500),
    [parseTgUrl],
  );

  return (
    <>
      <div className={styles.formItem}>
        <div className={styles.labelContainer}>
          <div className={cx(styles.label, styles.isRequired)}>Group / Channel Invite Link</div>
        </div>
        <Controller
          control={control}
          name="data.action_url"
          render={({ field, fieldState }) => {
            return (
              <Input
                className={styles.input}
                placeholder="Please paste the invite link to your Telegram group/channel"
                value={field?.value}
                onChange={val => {
                  field?.onChange(val);
                  setActionLoading(true);
                }}
                error={!!fieldState.error}
              />
            );
          }}
          rules={{
            required: true,
            validate: validateUrl!,
          }}
        />
        <ErrorMessage
          errors={errors}
          name={`data.action_url`}
          render={({ message, messages }) => {
            return (
              <div className={styles.errorMessage}>
                {message === 'noTgBot' ? (
                  <span>
                    Please{' '}
                    <span
                      className={styles.errorMessageLink}
                      onClick={() => window.open('https://t.me/debankdevbot')}>
                      add DeBank Bot
                    </span>{' '}
                    to your group/Channel as the admin first.
                  </span>
                ) : (
                  message
                )}
              </div>
            );
          }}
        />
      </div>
    </>
  );
};
